var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.902 4a1 1 0 011 1v6.772a1 1 0 11-2 0V5a1 1 0 011-1zM13.64 12.705a1 1 0 011 1v8.707a1 1 0 11-2 0v-8.707a1 1 0 011-1zM21.379 4a1 1 0 011 1v8.707a1 1 0 11-2 0V5a1 1 0 011-1zM3 14.64a1 1 0 100 2h1.902v5.773a1 1 0 102 0V16.64h1.902a1 1 0 100-2H3zM14.64 5a1 1 0 10-2 0v3.836h-1.902a1 1 0 100 2h2.855a.955.955 0 00.096 0h2.854a1 1 0 000-2H14.64V5zM18.48 16.576a1 1 0 100 2h1.899v3.837a1 1 0 102 0v-3.837h1.906a1 1 0 000-2H18.48z"
  })));
}
export default SvgFilterOutline;